import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'gatsby';
import LinkArrow from '/src/images/home/link-arrow.svg';

const Pricing = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.pricing' });

	return (
		<section id="pricing">
			<div className="content-wrapper">
				<h1>{t('thoughtful-pricing-for-everyone')}</h1>

				<button className="pricing-button">
					<Link to="/pricing">{t('see-membership-tiers')} <img className="desktop-screen" src={LinkArrow} alt={t('see-membership-tiers')} /></Link>
				</button>

			</div>
		</section>
	);
};

export default Pricing;
